export default __webpack_public_path__ + "static/media/ios_step_2_Cn.e4d6f1d5.jpg";